import React, { lazy } from 'react';
import AdsWithMostLeadValueImage from '../assets/images/dashboard/dashboardElements/ads-with-most-lead-value.png';
import FormSubmissionsImage from '../assets/images/dashboard/dashboardElements/form-submissions.png';
import LostDealValueImage from '../assets/images/dashboard/dashboardElements/lost-deal-value.png';
import MonthlyAdHistogramImage from '../assets/images/dashboard/dashboardElements/monthly-ad-histogram.png';
import OverviewImage from '../assets/images/dashboard/dashboardElements/overview.png';
import ProfitableAdsImage from '../assets/images/dashboard/dashboardElements/profitable-ads.png';
import ProfitsForEachAdImage from '../assets/images/dashboard/dashboardElements/profits-for-each-ad.png';
import ReferrerReportImage from '../assets/images/dashboard/dashboardElements/referrer-report.png';
import SeoReportImage from '../assets/images/dashboard/dashboardElements/seo-report.png';
import TotalAdRevenueImage from '../assets/images/dashboard/dashboardElements/total-ad-revenue.png';
import UnprofitableAdsImage from '../assets/images/dashboard/dashboardElements/unprofitable-ads.png';
import WastedAdSpendImage from '../assets/images/dashboard/dashboardElements/wasted-ad-spend.png';

export const defaultDashboard = [
  {
    w: 4, h: 2, x: 8, y: 6, i: 'TotalSessions',
  },
  {
    w: 4, h: 2, x: 12, y: 6, i: 'TotalRevenue',
  },
  {
    w: 4, h: 2, x: 16, y: 6, i: 'LostDealValue',
  },
  {
    w: 4, h: 2, x: 8, y: 8, i: 'WastedAdSpend',
  },
  {
    w: 8, h: 4, x: 8, y: 10, i: 'AdsThatLoseMoney',
  },
  // {
  //   w: 8, h: 4, x: 8, y: 8, i: 'AdsThatHavePotential',
  // },
  // {
  //   w: 8, h: 4, x: 0, y: 10, i: 'AdsThatEarnMoney',
  // },
  {
    w: 8, h: 4, x: 0, y: 6, i: 'ProfitableAds',
  },
  {
    w: 8, h: 4, x: 0, y: 2, i: 'MonthlyAdHistogram',
  },
  {
    w: 16, h: 2, x: 0, y: 0, i: 'Income',
  },
  {
    w: 8, h: 4, x: 0, y: 16, i: 'SeoReport',
  },
  {
    w: 8, h: 4, x: 10, y: 16, i: 'ReferrerReport',
  },
];

export const dashboardElementsOptions: any = {
  TotalSessions: {
    w: 4, h: 2, i: 'FormSubmissionsImage', label: 'Total Sessions', img: FormSubmissionsImage,
  },
  TotalRevenue: {
    w: 4, h: 2, i: 'TotalRevenue', label: 'Total Revenue', img: TotalAdRevenueImage,
  },
  LostDealValue: {
    w: 4, h: 2, i: 'LostDealValue', label: 'Lost Deal Value', img: LostDealValueImage,
  },
  WastedAdSpend: {
    w: 4, h: 2, i: 'WastedAdSpend', label: 'Wasted Ad Spend', img: WastedAdSpendImage,
  },
  AdsThatLoseMoney: {
    w: 8, h: 4, i: 'AdsThatLoseMoney', label: 'Ads that lose money', img: UnprofitableAdsImage,
  },
  AdsThatEarnMoney: {
    w: 8, h: 4, i: 'AdsThatEarnMoney', label: 'Ads that earn money', img: ProfitsForEachAdImage,
  },
  ProfitableAds: {
    w: 8, h: 4, i: 'ProfitableAds', label: 'Profitable ads', img: ProfitableAdsImage,
  },
  // AdsThatHavePotential: {
  //   w: 8, h: 4, i: 'AdsThatHavePotential', label: 'Ads with most potential', img: AdsWithMostLeadValueImage,
  // },
  MonthlyAdHistogram: {
    w: 8, h: 4, i: 'MonthlyAdHistogram', label: 'Monthly ad histogram', img: MonthlyAdHistogramImage,
  },
  Income: {
    w: 16, h: 2, i: 'Income', label: 'Income', img: OverviewImage,
  },
  SeoReport: {
    w: 8, h: 4, i: 'SeoReport', label: 'Seo Report', img: SeoReportImage,
  },
  ReferrerReport: {
    w: 8, h: 4, i: 'ReferrerReport', label: 'Referrer Report', img: ReferrerReportImage,
  },
};

export const dashboardElementOptionsLength = Object.keys(dashboardElementsOptions).length;

export const dashboardComponents: { [key: string]: React.LazyExoticComponent<React.ComponentType<any>> } = {
  TotalSessions: lazy(() => import('../components/dashboard/dashboardComponents/formSubmissions')),
  TotalRevenue: lazy(() => import('../components/dashboard/dashboardComponents/totalRevenue')),
  LostDealValue: lazy(() => import('../components/dashboard/dashboardComponents/lostDealValue')),
  AdsThatLoseMoney: lazy(() => import('../components/dashboard/dashboardComponents/adsThatLoseMoney')),
  AdsThatEarnMoney: lazy(() => import('../components/dashboard/dashboardComponents/adsThatEarnMoney')),
  ProfitableAds: lazy(() => import('../components/dashboard/dashboardComponents/profitableAds')),
  AdsThatHavePotential: lazy(() => import('../components/dashboard/dashboardComponents/adsThatHavePotential')),
  MonthlyAdHistogram: lazy(() => import('../components/dashboard/dashboardComponents/monthlyAdHistogram')),
  Income: lazy(() => import('../components/dashboard/dashboardComponents/income/income')),
  WastedAdSpend: lazy(() => import('../components/dashboard/dashboardComponents/wastedAdSpend')),
  SeoReport: lazy(() => import('../components/seoReport/seoReport')),
  ReferrerReport: lazy(() => import('../components/referrerReport/referrerReport')),
};
